var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.47986 5.42508L7.59058 5.42635L1.20631 8.44164L2.47986 5.42508ZM7.58931 4.56248H2.47986L1.20631 1.54592L7.58931 4.56248ZM0.170679 1.31182L1.7254 4.99378L0.170679 8.67574C0.0714412 8.90984 0.124876 9.18211 0.305539 9.36277C0.492564 9.5498 0.776282 9.59941 1.01674 9.48618L9.60205 5.43017C9.77126 5.35002 9.87686 5.1808 9.87813 4.99378C9.87941 4.80676 9.77126 4.63754 9.60205 4.55739L1.01547 0.500106C0.775009 0.386873 0.491292 0.436492 0.304267 0.623516C0.123604 0.804179 0.0701691 1.07645 0.169407 1.31054L0.170679 1.31182Z",
    fill: "#54FF99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.eb09c34255307695bfb71211f4556193.svg";
export { ForwardRef as ReactComponent };